export enum AdminBrandBannerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
